import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { QuoteDocument, RepQuoteFormState } from 'shared/types/quotes';
import { BasicQuoteForm } from './basic-quote-form';

interface Props {
  quote: QuoteDocument;
}

export function EditQuote(props: Props) {
  const methods = useForm<RepQuoteFormState>({
    defaultValues: props.quote,
  });

  const { setValue } = methods;

  useEffect(() => {
    setValue('products', props.quote.products);
    setValue('competitionInfoCompetition', props.quote.competitionInfoCompetition);
    setValue('dateRevised', new Date().toISOString());
  }, [props.quote.products, setValue, props.quote.competitionInfoCompetition]);

  return <BasicQuoteForm methods={methods} quote={props.quote} />;
}
